const isIdKey = _.memoize(
  (str = '') =>
    str === 'id' || str.slice(-2) === 'Id' || str.slice(-3) === '_id',
)

const $isIdKey = (str) => (_.isString(str) ? isIdKey(str) : false)

export default $isIdKey
